import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('connectionsPage');

    return {
        AUTHORIZE: t('authorize'),
        CANCEL: t('cancel'),
        COMING_Q3: t('comingQ3'),
        COMING_Q4: t('comingQ4'),
        CONNECT: t('connect'),
        CONNECTED_SYNCING: t('connectedSyncing'),
        DISCONNECT: t('disconnect'),
        INTEGRATIONS_LIVE: t('integrationsLive'),
        INTEGRATIONS_TOTAL: t('integrationsTotal'),
        LIVE: t('live'),
        MODAL_BODY: t('modalBody'),
        MODAL_STEP_1: t('modalStep1'),
        MODAL_STEP_2: t('modalStep2'),
        MODAL_STEP_3: t('modalStep3'),
        MODAL_STEP_4: t('modalStep4'),
        MODAL_TITLE: t('modalTitle'),
        NOTIFY_ME: t('notifyMe'),
        PAGE_TITLE: t('pageTitle'),
        READY_TO_CONNECT: t('readyToConnect'),
        SECTION_HINT: t('sectionHint'),
        TOAST_CONNECTED: t('toastConnected'),
        ZERO_CONNECTED: t('zeroConnected'),
        translate: (key: string) => t(key)
    };
};

export default useTranslation;
